module.exports = __webpack_public_path__ + "static/media/pustoparan-2.98d4e19f.png";